import(/* webpackMode: "eager" */ "C:\\Users\\Owner\\Documents\\GitHub\\opmode\\app\\global-error.tsx");
